<template>
  <v-container fluid>
    <main-header-plat-a />
    <main-header-plat-b :navBItems="navBItems" />
    <v-overlay-loader :status="status" />
    <v-row class="flex-nowrap">
      <div class="barLateral">
        <v-nav-draw-anam :anamIndex="anamIndex" :anamGroupShow="anamGroupShow" />
      </div>
      <div class="contentCentral mt-3">
        <v-card-form-anam :anamRoute="anamRoute" :observerHCP="observerHCP" />
        <v-card class="contentCardCentral secundary5" flat>
          <v-row
            v-if="infoAnam && infoAnam.length > 0"
            class="d-flex justify-end mx-10"
          >
            <v-menu
              v-model="showInfo"
              offset-y
              left
              :close-on-content-click="false"
              :close-on-click="true"
              content-class="info-menu-content"
            >
              <template v-slot:activator="{ on, attrs }">
                <span
                  v-bind="attrs"
                  v-on="on"
                  @dblclick.stop.prevent="selectNextInfo"
                  style="display: inline-flex; align-items: center; cursor: pointer;"
                >
                  <v-icon small color="info">
                    mdi-alert-circle-outline
                  </v-icon>
                </span>
              </template>

              <v-card class="pa-4 text-body-2">
                <v-row no-gutters>
                  <v-col cols="12">
                    <v-select
                      v-model="selectedVariable"
                      :items="infoAnam"
                      item-text="variable"
                      item-value="variable"
                      outlined
                      dense
                      clearable
                      hide-details
                    />
                  </v-col>

                  <v-col cols="12">
                    <div v-if="selectedInfo">
                      <div class="mt-2 mx-3 mb-3">
                        <p 
                          v-for="(paragraph, index) in selectedInfo.text" 
                          :key="index"
                          class="mb-2"
                        >
                          {{ paragraph }}
                        </p>
                      </div>

                      <div 
                        v-if="selectedInfo.question && (Array.isArray(selectedInfo.question) ? selectedInfo.question.length > 0 : selectedInfo.question.trim() !== '')"
                        class="mx-3"
                      >
                        <strong>
                          {{ Array.isArray(selectedInfo.question) && selectedInfo.question.length > 1 ? 'Preguntas:' : 'Pregunta:' }}
                        </strong>

                        <ul v-if="Array.isArray(selectedInfo.question)" class="pl-4 my-1">
                          <li v-for="(q, index) in selectedInfo.question" :key="index">
                            {{ q }}
                          </li>
                        </ul>

                        <span v-else>
                          {{ selectedInfo.question }}
                        </span>
                      </div>

                      <v-divider class="mx-3 mb-3" />

                      <div
                        v-if="selectedInfo.source && (
                          Array.isArray(selectedInfo.source)
                            ? selectedInfo.source.length > 0
                            : selectedInfo.source.trim() !== ''
                        )"
                        class="mt-2 mx-3 mb-3 text-caption"
                      >
                        <!-- Enlace para mostrar u ocultar las fuentes -->
                        <a
                          href="#"
                          role="button"
                          class="primary--text"
                          :aria-expanded="showSources"
                          @click.prevent="showSources = !showSources"
                        >
                          Fuente bibliográfica
                          <v-icon small class="ml-1">
                            {{ showSources ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
                          </v-icon>
                        </a>

                        <!-- Fuentes bibliográficas desplegables -->
                        <div v-if="showSources" class="mt-2">
                          <ul
                            v-if="Array.isArray(selectedInfo.source)"
                            class="pl-4 my-1"
                          >
                            <li
                              v-for="(src, index) in selectedInfo.source"
                              :key="index"
                            >
                              {{ src }}
                            </li>
                          </ul>

                          <!-- Si es un texto simple (String) -->
                          <span v-else>
                            {{ selectedInfo.source }}
                          </span>
                        </div>
                      </div>
                    </div>

                    <div v-else class="grey--text text--darken-1 mt-3 mx-3">
                      Selecciona una variable para consultar su información.
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-menu>
          </v-row>
          <v-row 
            class="mx-auto 
            contentRowCentral justify-center" 
            :style="{ width: $route.name === 'details-symptoms' ? '100%' : '80%' }"
          >
            <v-col cols="12" v-if="isRouteList">
              <div style="position: relative">
                <v-items-add-remove :items.sync="modelListProxy" />
                <v-sheet
                  v-if="observerHCP === true"
                  color="transparent"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 93%; z-index: 10"
                  class="rounded-lg"
                  @mousedown.stop.prevent
                  @click.stop.prevent
                >
                </v-sheet>
              </div>
            </v-col>
            <v-form class="contentForm">
              <v-col v-if="isRouteCrud" class="pt-0 mt-0">

                <span v-if="isRouteTraceDiag" class="d-flex mb-4 justify-center text-body-2">
                  Este apartado ha sido diseñado para permitir la recolección estructurada y detallada de información sobre los síntomas, 
                  con el objetivo de apoyar un análisis clínico y favorecer una comprensión más completa de su evolución.
                </span>

                <span v-if="isRouteTraceDiag" class="d-flex mt-7 mb-2 justify-center text-body-2">                
                  1. Concurrencias Temporales (CT): Defina aquí los bloques temporales (por ejemplo: 'Síntomas Depresivos', 'Síntomas Ansiosos', 'Síntomas de Bipolaridad').
                  La información de este cuadro servirá como plantilla maestra para agrupar y autocompletar la evolución de los síntomas individuales del segundo cuadro.
                </span>

                <v-crud
                  v-if="isRouteTraceDiag"
                  :headersCrud="headersCrud2"
                  :dataCrud.sync="dataCrudProxy2"
                  :editedItems="editedItems2"
                  :defaultItems="defaultItems2"
                  :formCrud="formCrud2"
                  :handleEvents="handleEvents2"
                  :clickRowInfo="clickRowInfo2"
                  :remove="remove2"
                  :checkboxNone="checkboxNone"
                  :handleEventsbox="handleEventsbox"
                  :observerHCP="observerHCP"
                />

                <div class="d-flex justify-end pt-2">
                  <span 
                    v-if="isRouteSpan" 
                    class="text-caption grey--text text--darken-1 text-right" 
                    style="white-space: pre-wrap; line-height: 1.25rem;"
                  >
                    {{ spanMsg }}
                  </span>
                </div>

                <span v-if="isRouteTraceDiag" class="d-flex mt-12 mb-2 justify-center text-body-2">
                  2. Detalle de Síntomas y Vinculación (CT): Evalúe cada síntoma y sus variables de impacto.
                  Para heredar datos automáticamente seleccione en la columna CT el patrón temporal al que pertenece el síntoma.
                  Si un síntoma no sigue el patrón general, deje la columna CT en blanco y configure sus parámetros evolutivos manualmente.
                </span>

                <div 
                  v-if="isRouteTraceDiag"
                  class="d-flex mt-4 mb-2 align-center justify-end"
                >
                  <span class="text-caption mr-1">
                    Ver variables no marcadas o manifestadas (M)
                  </span>

                  <v-checkbox
                    v-model="showNoSymptoms"
                    hide-details
                    dense
                    class="ma-0 pa-0"
                  ></v-checkbox>
                </div>
                
                <v-crud
                  :headersCrud="headersCrud"
                  :dataCrud.sync="dataCrudProxy"
                  :editedItems="editedItems"
                  :defaultItems="defaultItems"
                  :formCrud="formCrud"
                  :handleEvents="handleEvents"
                  :clickRowInfo="clickRowInfo"
                  :remove="remove"
                  :spanMsg="spanMsg"
                  :checkboxNone="checkboxNone"
                  :handleEventsbox="handleEventsbox"
                  :observerHCP="observerHCP"
                />
                
                <v-dialog-trace-diag 
                  class="justify-end" 
                  v-if="isRouteTraceDiag" 
                  :dialogTraceDiag="dialogTraceDiag" 
                  :traceDiagBtn="traceDiagBtn" 
                  :headersGroupsT="headersGroupsT" 
                  :dataGroupsT="dataGroupsT" 
                  :headersCodeT="headersCodeT" 
                  :dataCodeT="dataCodeT" 
                  :checkboxDS="checkboxDS"
                  :handleEventsbox="handleEventsbox"
                />
              </v-col>
              <v-col v-if="isRouteCrudExpan">
                <v-crud-expandable
                  :headersCrud="headersCrud"
                  :dataCrud.sync="dataCrudProxy2"
                  :editedItems="editedItems"
                  :defaultItems="defaultItems"
                  :formCrud="formCrud"
                  :handleEvents="handleEvents"
                  :clickRowInfo="clickRowInfo"
                  :remove="remove"
                  :spanMsg="spanMsg"
                  :checkboxNone="checkboxNone"
                  :handleEventsbox="handleEventsbox"
                  :observerHCP="observerHCP"
                />
              </v-col>
              <v-col v-if="isRouteCrudExpan2" class="mt-16">
                <v-crud-expandable
                  :headersCrud="headersCrud2"
                  :dataCrud.sync="dataCrudProxy2"
                  :editedItems="editedItems2"
                  :defaultItems="defaultItems2"
                  :formCrud="formCrud2"
                  :handleEvents="handleEvents2"
                  :clickRowInfo="clickRowInfo2"
                  :remove="remove2"
                  :spanMsg="spanMsg"
                  :checkboxNone="checkboxNone"
                  :handleEventsbox="handleEventsbox"
                  :observerHCP="observerHCP"
                />
              </v-col>
                <div style="position: relative">
                  <v-form-base
                    v-if="
                      schemaForm &&
                      modelForm &&
                      Object.keys(schemaForm).length &&
                      Object.keys(modelForm).length
                    "
                    class="d-flex justify-center"
                    :schema="schemaForm"
                    :model="modelForm"
                    @input="handleEvents"
                  />
                  <v-sheet
                    v-if="observerHCP === true"
                    color="transparent"
                    style="position: absolute; inset: 0; z-index: 10"
                    class="rounded-lg"
                    @mousedown.stop.prevent
                    @click.stop.prevent
                  >
                  </v-sheet>
                </div>
              <v-col v-if="isRouteCrud2">
                <v-crud
                  :headersCrud="headersCrud"
                  :dataCrud.sync="dataCrudProxy"
                  :editedItems="editedItems"
                  :defaultItems="defaultItems"
                  :formCrud="formCrud"
                  :handleEvents="handleEvents"
                  :clickRowInfo="clickRowInfo"
                  :remove="remove"
                  :spanMsg="spanMsg"
                  :checkboxNone="checkboxNone"
                  :handleEventsbox="handleEventsbox"
                  :observerHCP="observerHCP"
                />
                <span v-if="isRouteSpan2" class="d-flex text-caption justify-end">{{
                  spanMsg
                }}</span>
              </v-col>
              <v-carousel
                :continuous="false"
                :show-arrows="false"
                delimiter-icon="mdi-circle"
                hide-delimiter-background
                height="auto"
                class="d-flex justify-center secundary5 custom-carousel"
              >
                <v-carousel-item v-for="(items, index) in modelSlides" :key="index">
                  <v-sheet class="d-flex secundary5 justify-center">
                    <v-form
                      class="d-flex flex-nowrap secundary5 justify-center contentCentral mx-3"
                      @input="handleEvents"
                    >
                      <div style="position: relative">
                        <v-form-base
                          :schema="items.schemaForm"
                          :model="items.modelForm"
                          @input="handleEvents"
                          class="d-flex justify-center mb-16"
                        />
                      
                        <v-sheet
                          v-if="observerHCP === true"
                          color="transparent"
                          style="position: absolute; top: 0; left: 0; width: 100%; height: 93%; z-index: 10"
                          class="rounded-lg"
                          @mousedown.stop.prevent
                          @click.stop.prevent
                        >
                        </v-sheet>
                      </div>
                    </v-form>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
              <v-overlay
                :value="overlay"
                @update:value="internalOverlay = $event"
                class="d-flex align-star justify-center"
                style="z-index: 1000; position: absolute"
              >
                <v-row class="d-flex justify-center my-5">
                  <v-card min-height="200" width="70%" class="secundary6">
                    <v-card-title class="text-body-1 font-weight-bold justify-center">
                      Aviso
                    </v-card-title>
                    <v-card-text class="text-body-2">
                      {{ overlayMessage }}
                    </v-card-text>
                    <v-card-actions class="mx-auto mb-5">
                      <v-btn
                        color="primary"
                        class="d-flex mx-auto justify-center"
                        @click="toggleOverlay()"
                      >
                        IR A INDEX
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-row>
              </v-overlay>
            </v-form>
          </v-row>
          <v-row class="mx-auto bannerAction ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <v-banner-action-form
                :bannerActionItems="bannerActionItems"
                :save="save"
                :nextPage="nextPage"
                v-if="observerHCP === false && hasPermission === true"
              />
            </v-col>
            <v-snack-bar :snackbar="snackbar" />
          </v-row>
        </v-card>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import MainHeaderPlatB from '@/components/includes/MainHeaderPlatB.vue';
import VOverlayLoader from '@/components/base/VOverlayLoader.vue';
import VNavDrawAnam from '@/components/base/VNavDrawAnam.vue';
import VCardFormAnam from '@/components/base/VCardFormAnam.vue';
import VItemsAddRemove from '@/components/base/VItemsAddRemove.vue';
import VCrud from '@/components/base/VCrud.vue';
import VCrudExpandable from '@/components/base/VCrudExpandable.vue';
import VFormBase from 'vuetify-form-base';
import VDialogTraceDiag from '@/components/base/VDialogTraceDiag.vue';
import VBannerActionForm from '@/components/base/VBannerActionForm.vue';
import VSnackBar from '@/components/base/VSnackBar.vue';


export default {
  name: 'AnamnesisPage',
  components: {
    MainHeaderPlatA,
    MainHeaderPlatB,
    VOverlayLoader,
    VNavDrawAnam,
    VCardFormAnam,
    VItemsAddRemove,
    VCrud,
    VCrudExpandable,
    VFormBase,
    VDialogTraceDiag,
    VBannerActionForm,
    VSnackBar,
  },
  props: [
    'navBItems',
    'anamRoute',
    'headersCrud',
    'dataCrud',
    'editedItems',
    'defaultItems',
    'headersCrud2',
    'dataCrud2',
    'editedItems2',
    'defaultItems2',
    'headersGroupsT', 
    'dataGroupsT', 
    'headersCodeT', 
    'dataCodeT',
    'checkboxDS',
    'handleEventsbox',
    'spanMsg',
    'dialogTraceDiag',
    'traceDiagBtn',
    'checkboxNone',
    'modelList',
    'formCrud',
    'formCrud2',
    'handleEventsCrud',
    'clickRowInfo',
    'clickRowInfo2',
    'remove',
    'remove2',
    'schemaForm',
    'modelForm',
    'modelSlides',
    'handleEvents',
    'handleEvents2',
    'bannerActionItems',
    'save',
    'nextPage',
    'infoAnam',
    'snackbar',
    'overlay',
    'overlayMessage',
    'toggleOverlay',
    'status',
  ],
  data() {
    return {
      showInfo: false,
      showSources: false,
      expandedInfo: {},
      selectedVariable: null,
      showNoSymptoms: false,
    };
  },
  computed: {
    ...mapGetters('anamPermissions', ['anamIndex', 'anamGroupShow', 'hasPermission', 'observerHCP']),

    selectedInfo() {
      return this.infoAnam.find(
        item => item.variable === this.selectedVariable
      ) || null;
    },

    dataCrudProxy: {
      get() {
        if (!this.dataCrud) return [];

        if (this.showNoSymptoms) {
          return this.dataCrud;
        }

        return this.dataCrud.filter(item => {
          return item.ds_manifestation_M?.option !== 'No';
        });
      },

      set(newValue) {
        if (this.showNoSymptoms) {
          // Reemplazamos this.dataCrud = newValue por el emit del .sync
          this.$emit('update:dataCrud', newValue); 
        } else {
          const hiddenItems = this.dataCrud.filter(
            item => item.ds_manifestation_M?.option === 'No'
          );
          
          // Reemplazamos la asignación por el emit del .sync
          this.$emit('update:dataCrud', [...newValue, ...hiddenItems]);
        }
      }
    },
    dataCrudProxy2: {
      get() {
        return this.dataCrud2;
      },
      set(value) {
        this.$emit('update:dataCrud2', value);
      }
    },
    isRouteCrud() {
      switch (this.$route.name) {
        case 'interview':
          return true;
        case 'dysfunctions':
          return true;
        case 'symptoms-muscular':
          return true;
        case 'family':
          return true;
        case 'losses':
          return true;
        case 'details-symptoms':
          return true;
        case 'diagTreatment':
          return true;
        default:
          return false;
      }
    },
    isRouteCrud2() {
      switch (this.$route.name) {
        case 'filiation':
          return true;
        case 'memory':
          return true;
        case 'relationshipFam':
          return true;
        default:
          return false;
      }
    },
    isRouteSpan() {
      switch (this.$route.name) {
        case 'family':
          return true;
        case 'violenceFam':
          return true;
        case 'details-symptoms':
          return true;
        default:
          return false;
      }
    },
    isRouteSpan2() {
      switch (this.$route.name) {
        case 'memory':
          return true;
        case 'relationshipFam':
          return true;
        default:
          return false;
      }
    },
    isRouteTraceDiag() {
      switch (this.$route.name) {
        case 'details-symptoms':
          return true;
        default:
          return false;
      }
    },
    isRouteCrudExpan() {
      switch (this.$route.name) {
        case 'violenceFam':
          return true;
        case 'substances':
          return true;
        case 'violenceSoc':
          return true;
        case 'academic':
          return true;
        case 'labor':
          return true;
        case 'violence':
          return true;
        case 'basic-studies':
          return true;
        case 'superior-studies':
          return true;
        case 'jobs':
          return true;
        case 'membersfam':
          return true;
        case 'mental':
          return true;
        case 'medical':
          return true;
        case 'drugs':
          return true;
        case 'criminal':
          return true;
        case 'medications':
          return true;
        case 'relevant-events':
          return true;
        default:
          return false;
      }
    },
    isRouteCrudExpan2() {
      switch (this.$route.name) {
        case 'diagTreatment':
          return true;
        default:
          return false;
      }
    },
    modelListProxy: {
      get() {
        return Array.isArray(this.modelList) ? this.modelList : [];
      },
      set(value) {
        this.$emit('update:modelList', value);
      }
    },
    isRouteList() {
      switch (this.$route.name) {
        case 'reason':
          return true;
        case 'CAxAFSMxClarifications':
          return true;
        case 'CAxAFFxClarifications':
          return true;
        case 'CAxACGxClarifications':
          return true;
        case 'CAxARPxClarifications':
          return true;
        case 'CAxAAMxClarifications':
          return true;
        case 'CAxACOxClarifications':
          return true;
        case 'CAxAFAxClarifications':
          return true;
        case 'CAxASCxClarifications':
          return true;
        case 'CAxASXxClarifications':
          return true;
        case 'CAxAALxClarifications':
          return true;
        case 'CAxCExClarifications':
          return true;
        case 'ANxClarifications':
          return true;
        case 'generalObservation':
          return true;
        default:
          return false;
      }
    },
    internalOverlay: {
      get() {
        return this.overlay;
      },
      set(value) {
        // Si el valor cambia (ej. al cerrar el overlay), 
        // llamamos a la función toggle que recibimos por prop
        if (value !== this.overlay) {
          this.toggleOverlay();
        }
      }
    }
  },
  mounted() {
    this.loadPermissionsHCP();
  },
  methods: {
    ...mapActions('anamPermissions', ['loadPermissionsHCP']),

    toggleInfo(index) {
      this.$set(
        this.expandedInfo,
        index,
        !this.expandedInfo[index]
      );
    },

    selectNextInfo() {
      if (!this.infoAnam || this.infoAnam.length === 0) {
        return;
      }

      const currentIndex = this.infoAnam.findIndex(
        item => item.variable === this.selectedVariable
      );

      const nextIndex =
        currentIndex === -1
          ? 0
          : (currentIndex + 1) % this.infoAnam.length;

      this.selectedVariable = this.infoAnam[nextIndex].variable;

      this.showInfo = true;
    }
  },
};
</script>

<style>
.barLateral {
  min-width: 60px;
}

.contentCentral {
  width: 96%;
}

.contentCardCentral {
  width: 98.5%;
  margin-top: 70px;
}

.contentRowCentral {
  width: 80%;
  min-height: 390px;
}

.contentForm {
  min-height: 390px;
}

.bannerAction {
  width: 87%;
  height: 48px;
}

.custom-carousel .v-carousel__controls__item {
  color: #1976D2 !important;
}

.custom-carousel .v-carousel__controls__item.v-carousel__controls__item--active {
  color: #1976D2 !important;
}

.v-menu__content.info-menu-content {
  z-index: 999999 !important;
}

@media (max-width: 599px) {
  .v-menu__content.info-menu-content {
    max-width: calc(100vw - 48px) !important;
    margin-left: 24px !important;
    box-sizing: border-box;
  }
}
</style>
